// extracted by mini-css-extract-plugin
export var hideEditor = "_sd-2";
export var infoIcon = "_sd-3";
export var label = "_sd-1";
export var labelContainer = "_sd-0";
export var readonlyText = "_sd-4";